export const environment = {
  production: false,
  bpostBusyMessage: false
};
